export const PasswordPolicyText = [
  '8文字以上のパスワードを指定してください。',
  '「半角数字」「半角英字小文字」「半角英字大文字」「記号」がすべて1文字は含まれるようにしてください。',
  "記号：` = + - ^ $ * . [ ] { } ( ) ? ! @ # % & /  , > < ' : ; | _ ~ ",
];
